// src/lib/api.ts — Frontend API client for Cloudflare Worker and local Tauri

export const API_BASE = import.meta.env.VITE_API_BASE || 'https://grea-desktop-server.superiorchemco.workers.dev'

export async function chat(provider: string, prompt: string) {
  const res = await fetch(`${API_BASE}/api/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      provider,
      model: 'gpt-4o-mini',
      messages: [{ role: 'user', content: prompt }],
    }),
  })
  return res.json()
}

export async function getGroups() {
  const res = await fetch(`${API_BASE}/api/groups`)
  return res.json()
}

export async function getRuns(groupId?: string) {
  const url = groupId ? `${API_BASE}/api/runs?group_id=${groupId}` : `${API_BASE}/api/runs`
  const res = await fetch(url)
  return res.json()
}

export async function submitRun(groupId: string, agentType: string, prompt: string) {
  const res = await fetch(`${API_BASE}/api/runs`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ group_id: groupId, agent_type: agentType, prompt }),
  })
  return res.json()
}

export async function getProviders() {
  const res = await fetch(`${API_BASE}/api/providers`)
  return res.json()
}

export async function getLeads() {
  const res = await fetch(`${API_BASE}/api/leads`)
  return res.json()
}

export async function getHealth() {
  const res = await fetch(`${API_BASE}/api/health`)
  return res.json()
}

export async function getAgentsStatus() {
  const res = await fetch(`${API_BASE}/api/agents/status`)
  return res.json()
}

export async function dispatchAgent(group: string, prompt: string) {
  const res = await fetch(`${API_BASE}/api/agents/dispatch`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ group, prompt }),
  })
  return res.json()
}